import { render, staticRenderFns } from "./PdfmdpjanIndextab6.vue?vue&type=template&id=2ddd13fe"
import script from "./PdfmdpjanIndextab6.vue?vue&type=script&lang=js"
export * from "./PdfmdpjanIndextab6.vue?vue&type=script&lang=js"
import style0 from "./PdfmdpjanIndextab6.vue?vue&type=style&index=0&id=2ddd13fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports